package apofnj.pojos

enum class URL_HANDLES {
    ENTITY_ID
}